<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">
      <vx-card title="Account" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="user_data.avatar" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Name</td>
                <td>{{ user_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Email</td>
                <td>{{ user_data.email }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Verified</td>
                <td>{{ user_data.status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Role</td>
                <td>Vendor</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{name: 'admin-user-vendor-edit', params: { id: $route.params.id }}"
            >Edit</vs-button>
            <!-- <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
            >Delete</vs-button> -->
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Professional details" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Total Points Earned</td>
                <td>{{ user_data.professional.points }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Promo Code</td>
                <td>{{ user_data.professional.promo_code }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Vendor Category</td>
                <td>{{ user_data.professional_category }}</td>
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional_category_additional">Additional Category</td>
                <td>{{ user_data.professional_category_additional }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Business Name</td>
                <td>{{ user_data.professional.business_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Address</td>
                <td>{{ user_data.professional.address }}</td>
              </tr>
              <tr>
                <td class="font-semibold">County</td>
                <td>{{ user_data.professional.county_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Location</td>
                <td>{{ user_data.professional.location }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile Number</td>
                <td>{{ user_data.professional.mobile_phone }}</td>
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional.business_phone">Business Phone Number (optional)</td>
                <td>{{ user_data.professional.business_phone }}</td>
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional.ein">EIN (Optional)</td>
                <td>{{ user_data.professional.ein }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Have liability insurance (Optional)</td>
                <vs-switch v-model="user_data.professional.liability_insurance" disabled />
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional.website">Website (Optional)</td>
                <td><a target="_blank" :href="user_data.professional.website">{{ user_data.professional.website }}</a></td>
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional.facebook">Facebook (Optional)</td>
                <td><a target="_blank" :href="user_data.professional.facebook">{{ user_data.professional.facebook }}</a></td>
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional.instagram">Instagram (Optional)</td>
                <td><a target="_blank" :href="user_data.professional.instagram">{{ user_data.professional.instagram }}</a></td>
              </tr>
              <tr>
                <td class="font-semibold" v-if="user_data.professional.pinterest">Pinterest (Optional)</td>
                <td><a target="_blank" :href="user_data.professional.pinterest">{{ user_data.professional.pinterest }}</a></td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Additional details" class="mb-base">
            <table>
              <tr v-if="(user_data.professional.vip !== null)">
                <td width="40%" class="font-semibold">Membership</td>
                <td v-if="user_data.professional.vip">Vip</td>
                <td v-else="user_data.professional.vip">Regular</td>
              </tr>
              <tr v-if="user_data.vendor_additional.budget">
                <td class="font-semibold">Minimum acceptable amount?</td>
                <td>{{ user_data.vendor_additional.budget }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.willing_to_travel !== '')">
                <td class="font-semibold">Willing to travel?</td>
                <td>{{ user_data.vendor_additional.willing_to_travel }}</td>
              </tr>


              <tr v-if="(user_data.vendor_additional.venue_space)">
                <td class="font-semibold">
                  Venue Space
                  <span style="color:red">
                    *
                  </span>
                </td>
                <td>{{ user_data.vendor_additional.venue_space.join(', ') }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_in_house_catering)">
                <td class="font-semibold">
                  Do you require the use of in-house catering?
                  <span style="color:red">
                    *
                  </span></td>
                <td>{{ user_data.vendor_additional.venue_in_house_catering }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_offer_bar_services)">
                <td class="font-semibold">Do you offer bar services/packages?</td>
                <td>{{ user_data.vendor_additional.venue_offer_bar_services }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_bar_service)">
                <td class="font-semibold">
                  Client must use in-house bar services?
                  <span style="color:red">
                    *
                  </span>
                </td>
                <td>{{ user_data.vendor_additional.venue_bar_service }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_offer_all_inclusive)">
                <td class="font-semibold">Do you offer all inclusive (Tables, chairs, napkins, cutleries, glass, catering, alcohol, servers etc.)?</td>
                <td>{{ user_data.vendor_additional.venue_offer_all_inclusive }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_all_inclusive)">
                <td class="font-semibold">
                  Client must use all inclusive?
                </td>
                <td>{{ user_data.vendor_additional.venue_all_inclusive }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_approved_list_vendors)">
                <td class="font-semibold">
                  Do you have an approved list of vendors?
                </td>
                <td>{{ user_data.vendor_additional.venue_approved_list_vendors }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_event_coordinator)">
                <td class="font-semibold">
                  Do you require day of event coordinator?
                  <span style="color:red">
                    *
                  </span></td>
                <td>{{ user_data.vendor_additional.venue_event_coordinator }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_rooms)">
                <td class="font-semibold">Do you have Bride’s and Groom’s room?</td>
                <td>{{ user_data.vendor_additional.venue_rooms.join(', ') }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_packing_facilities)">
                <td class="font-semibold">Do you have free parking facilities?</td>
                <td>{{ user_data.vendor_additional.venue_packing_facilities }}</td>
              </tr>
              <tr v-if="(user_data.vendor_additional.venue_theme)">
                <td class="font-semibold">Venue theme:</td>
                <td>{{ user_data.vendor_additional.venue_theme.join(', ') || user_data.vendor_additional.venue_theme }}</td>
              </tr>





            </table>
          </vx-card>
        </div>
      </div>

      <!-- Tabs -->
      <vx-card>
        <vs-tabs :value="tab">
          <vs-tab label="Service Requests" icon-pack="feather" icon="icon-package" v-if="user_data.service_request.length">
            <div>
              <vs-table @selected="directToServiceRequest" max-items="10" pagination :data="user_data.service_request">
                <template slot="thead">
                  <vs-th>Event Name</vs-th>
                  <vs-th>Event Date</vs-th>
                  <vs-th>County</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Category</vs-th>
                  <vs-th>Budget</vs-th>
                  <vs-th>Quotes</vs-th>
                  <vs-th sort-key="is_accepted">Accepted</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].event.name">{{ data[indextr].event.name }}</vs-td>

                    <vs-td :data="data[indextr].event_date">{{ data[indextr].event_date }}</vs-td>

                    <vs-td :data="data[indextr].location">{{ data[indextr].county_name }}</vs-td>

                    <vs-td :data="data[indextr].location">{{ data[indextr].location }}</vs-td>

                    <vs-td :data="data[indextr].category_name">{{ data[indextr].category_name }}</vs-td>

                    <vs-td :data="data[indextr].budget">${{ data[indextr].budget }}</vs-td>

                    <vs-td :data="data[indextr].quotes.length">{{ data[indextr].quotes.length }}</vs-td>

                    <vs-td :data="data[indextr].quote_already_accepted"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].quote_already_accepted ? 'text-primary' : 'text-grey')]" /></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Quotes" icon-pack="feather" icon="icon-dollar-sign" v-if="user_data.quotes.length">
            <div>
              <vs-table @selected="directToServiceRequestFromQuote" max-items="10" pagination :data="user_data.quotes">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Quote Amount</vs-th>
                  <vs-th sort-key="is_accepted">Accepted</vs-th>
                  <vs-th>Has Conversation</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].service_request.category.name">{{ data[indextr].service_request.category.name }}</vs-td>

                    <vs-td :data="data[indextr].quote_amount">${{ data[indextr].quote_amount }}</vs-td>

                    <vs-td :data="data[indextr].is_accepted"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].is_accepted ? 'text-primary' : 'text-grey')]" /></vs-td>

                    <vs-td :data="data[indextr].has_conversation"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].has_conversation ? 'text-primary' : 'text-grey')]" /></vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Points" icon-pack="feather" icon="icon-award" v-if="user_data.points.length">
            <div>
              <vs-table @selected="directToServiceRequestFromQuote" max-items="10" pagination :data="user_data.points">
                <template slot="thead">
                  <vs-th>Action</vs-th>
                  <vs-th>Points</vs-th>
                  <vs-th>Date</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].details.title">{{ data[indextr].details.title }}</vs-td>
                    <vs-td :data="data[indextr].details.points">{{ data[indextr].details.points }}</vs-td>
                    <vs-td :data="data[indextr].created_date">{{ data[indextr].created_date }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>
          <vs-tab label="Preferences" icon-pack="feather" icon="icon-lock">
            <div class="block overflow-x-auto">
              <vs-row>
                <vs-col vs-type="flex" vs-w="6">
                  <div class="mb-4">
                    <h6 class="mb-4">Email Preference</h6>

                    <div class="flex items-center mb-4">
                      <vs-switch v-model="user_data.email_service_request" disabled />
                      <span class="ml-4">Service Requests</span>
                    </div>
                    <div class="flex items-center mb-4">
                      <vs-switch v-model="user_data.email_quote" disabled />
                      <span class="ml-4">Quotes</span>
                    </div>
                  </div>
                </vs-col>
                <vs-col vs-type="flex" vs-w="6">
                  <div class="mb-4">
                    <h6 class="mb-4">Notification preferences</h6>

                    <div class="flex items-center mb-4">
                      <vs-switch v-model="user_data.notify_quote" disabled />
                      <span class="ml-4">Quotes</span>
                    </div>
                    <div class="flex items-center mb-4">
                      <vs-switch v-model="user_data.notify_message" disabled />
                      <span class="ml-4">Chat Messages</span>
                    </div>
                    <div class="flex items-center mb-4">
                      <vs-switch v-model="user_data.notify_service_request" disabled />
                      <span class="ml-4">Service Request Messages</span>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
            </div>
          </vs-tab>
          <vs-tab label="About" icon-pack="feather" icon="icon-user"  v-if="user_data.professional.about">
            <div class="block overflow-x-auto">
              {{user_data.professional.about}}
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  data () {
    return {
      user_data: null,
      user_not_found: false,
      tab: 0
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    }
  },
  methods: {
    directToServiceRequest (tr) {
      this.$router
        .push(`/admin/service-request/view/${tr.id}`)
        .catch(() => {})
    },
    directToServiceRequestFromQuote (tr) {
      this.$router
        .push(`/admin/service-request/view/${tr.service_request.id}?tab=quote`)
        .catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      /*this.$router.push({ name: "app-user-list" })
      this.showDeleteSuccess()*/

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch('userManagement/deleteUser', this.user_data.id)
        .then(()   => { this.$router.push({name:'admin-user-vendor'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The user was successfully deleted'
      })
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'User - Vendor')
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const userId = this.$route.params.id
    this.$store
      .dispatch('userManagement/fetchUser', {
        userId,
        action : 'view',
        role : 'vendor'
      })
      .then((res) => {
        this.user_data = res.data.data
        if (this.$route.query.tab === 'quote' && this.user_data.quotes.length && this.user_data.service_request.length) {
          this.tab = 1
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err)
      })
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      padding-left:5px
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
